import { jsx } from "react/jsx-runtime";
import { createContext, useCallback, useMemo, useContext } from "react";
import { useFormikContext } from "formik";
const Context = createContext({});
const FormHelpersProvider = ({ children }) => {
  const { touched, setErrors, setFieldValue, setFieldTouched, getFieldProps, setValues, setTouched } = useFormikContext();
  const customSetTouched = useCallback(
    (newValues) => {
      setTouched({
        ...touched,
        ...newValues
      });
    },
    [touched, setTouched]
  );
  const value = useMemo(
    () => ({
      setFieldValue,
      setFieldTouched,
      getFieldProps,
      setValues,
      setErrors,
      setTouched: customSetTouched
    }),
    [setFieldValue, setFieldTouched, getFieldProps, setValues, customSetTouched]
  );
  return /* @__PURE__ */ jsx(Context.Provider, { value, children });
};
const useFormHelpers = () => {
  const context = useContext(Context);
  return context;
};
export {
  FormHelpersProvider,
  useFormHelpers
};
